import { NavItemEnum } from '../../../constants/routing/NavItems';
import { UseCases, useCasesQueryParamKey } from './useCaseConstants';
export const getUseCasesByPage = page => {
  switch (page) {
    case NavItemEnum.MARKETING:
    case NavItemEnum.CONTENT:
    case NavItemEnum.MARKETING_PLUS:
      return [UseCases.MARKETING];
    case NavItemEnum.SMART_CRM:
    case NavItemEnum.SALES:
    case NavItemEnum.DATA:
    case NavItemEnum.COMMERCE:
    case NavItemEnum.FREE:
      return [UseCases.SALES];
    case NavItemEnum.SERVICE:
      return [UseCases.SERVICE];
    case NavItemEnum.SUITE:
      return [UseCases.MARKETING, UseCases.SALES, UseCases.SERVICE];
    case NavItemEnum.HUBSPOT_CREDITS:
    case NavItemEnum.BUNDLE:
    default:
      return [UseCases.MARKETING];
  }
};
export const getValidUniqueUseCasesParams = (searchParams, availableUseCases) => {
  const search = typeof searchParams === 'string' ? new URLSearchParams(searchParams) : searchParams;
  const useCases = search.getAll(useCasesQueryParamKey);

  // Validation (case-insensitive)
  const availableUpperCase = new Set(availableUseCases);
  const isValidUseCase = useCase => {
    return availableUpperCase.has(useCase);
  };
  const normalizedUseCases = [];
  let wasModified = false;
  for (const useCase of useCases) {
    const upperCase = useCase.toUpperCase();
    const isValid = isValidUseCase(upperCase);
    const isDuplicate = normalizedUseCases.some(uc => uc === upperCase);
    const wasNormalized = useCase !== upperCase;
    if (!isValid || isDuplicate || wasNormalized) {
      wasModified = true;
    }
    if (isValid && !isDuplicate) {
      normalizedUseCases.push(upperCase);
    }
  }

  // Create new search params
  search.delete(useCasesQueryParamKey);
  for (const useCase of normalizedUseCases) {
    search.append(useCasesQueryParamKey, useCase);
  }
  return {
    wasModified,
    search: search.toString(),
    useCases: normalizedUseCases
  };
};